/**
 * Ryan O'Dowd
 * 2025-06-10
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale}) => {
  return {
    container: (top, right) => {
      return {
        position: 'absolute',
        top: top + (top - (globalScale * top)),
        right: right + (right - (globalScale * right)),
      };
    },
  };
};

export default getStyles;
